import type { Campaign } from "./campaign.types";
import type { AsyncStatus } from "../redux/base.state";
import type { Pagination } from "../../../types/pagination.types";
import type { Product } from "../product/product.types";

export interface CampaignState {
  /** Campaigns list */
  campaigns: Campaign[];
  campaignsStatus: AsyncStatus;
  campaignsError: string | null;
  campaignsPagination: Pagination | null;

  /** Campaign detail */
  campaign: Campaign | null;
  campaignStatus: AsyncStatus;
  campaignError: string | null;
  items: Product[];
  pagination: Pagination | null;
}

export const initialCampaignState: CampaignState = {
  campaigns: [],
  campaignsStatus: "idle",
  campaignsError: null,
  campaignsPagination: null,

  campaign: null,
  campaignStatus: "idle",
  campaignError: null,
  items: [],
  pagination: null,
};